import React, { forwardRef } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

type SubmitButtonProps = React.ComponentProps<"button"> & {
  loadingText: string;
  isLoading: boolean;
};

const SubmitButton = forwardRef<HTMLButtonElement, SubmitButtonProps>(
  ({ isLoading, loadingText, title, ...props }, ref) => {
    return (
      <Button
        type="submit"
        className="w-full"
        disabled={isLoading}
        ref={ref}
        {...props}
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            {loadingText}
          </>
        ) : (
          title
        )}
      </Button>
    );
  }
);

SubmitButton.displayName = "SubmitButton";

export default SubmitButton;
